module.exports = __webpack_public_path__ + "static/media/messenger-gray.a16ca822.svg";